import * as t from './actionTypes';
import type { SenderCreateFormContextType } from './contexts/SenderCreateFormProvider';
import type {
  DefaultSender,
  SmsSender,
  AuthedEmail,
  SmsMessageType,
  SmsEsps,
  ValidSendDomain,
  DeleteAndReplaceEmailSender,
} from './types';

export const fetchSenders = () => ({
  type: t.FETCH_SENDERS_REQUEST,
});

export const fetchSendersResponse = (
  smsSenders: SmsSender[],
  authedEmails: AuthedEmail[],
  smsMessageTypes: SmsMessageType[],
  smsEsps: SmsEsps[],
  validSendDomains: ValidSendDomain[],
) => ({
  type: t.FETCH_SENDERS_RESPONSE,
  smsSenders,
  authedEmails,
  smsMessageTypes,
  smsEsps,
  validSendDomains,
});

export const fetchSendersError = () => ({
  type: t.FETCH_SENDERS_ERROR,
});

export const setDefaultSenderRequest = (defaultSender: DefaultSender) => ({
  type: t.SET_DEFAULT_SENDER_REQUEST,
  defaultSender,
});

export const editSenderRequest = (sender: AuthedEmail) => ({
  type: t.EDIT_SENDER_REQUEST,
  sender,
});

export const deleteAndReplaceSenderRequest = (
  deleteAndReplaceSender: DeleteAndReplaceEmailSender,
) => ({
  type: t.DELETE_SENDER_REQUEST,
  deleteAndReplaceSender,
});

export const createSenderRequest = (data: SenderCreateFormContextType) => ({
  type: t.CREATE_SENDER_REQUEST,
  data,
});
